import React from 'react';
import { AppBar, Toolbar,  Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {

  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <Button color="inherit" component={RouterLink} to="/impressum">
          Impressum
        </Button>
        <Button color="inherit" component={RouterLink} to="/privacy-policy">
          Privacy-Policy
        </Button>
        
      </Toolbar>
    </AppBar>
  );
};

export default Footer;
